export default __webpack_public_path__ + "static/media/my-kuchiguse-counter.131d24b2.png";